const publicOptions = [
  {
    screenName: 'Root',
    pathname: '/',
    exact: true,
  },
  {
    screenName: 'Login',
    pathname: '/account/login',
    exact: true,
  },
];

export default publicOptions;
